import * as React from 'react'
import Dropzone, { DropzoneProps } from 'react-dropzone'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  disabled?: boolean
  onDrop?: DropzoneProps['onDrop']
  fullSize?: boolean
}

export const CvDropzone = ({ onDrop, disabled, fullSize = false }: Props) => {
  return (
    <Dropzone accept={ACCEPTED_DOCUMENTS} onDrop={onDrop} disabled={disabled}>
      {({ getInputProps, getRootProps, isDragActive }) => (
        <div {...getRootProps()}>
          <Box
            padding="s24"
            borderRadius={{ all: 'abs006' }}
            border={{
              all: {
                width: 's2',
                style: 'dashed',
                color: isDragActive ? 'radicalRed1000' : 'grey400',
              },
            }}
            alignItems="center"
            justifyContent="center"
            style={{
              cursor: 'pointer',
              position: 'relative',
            }}
            gap="s16"
            minHeight={fullSize ? 's600' : undefined}
          >
            <input {...getInputProps()} />
            <Box gap="s4" alignItems="center">
              <Text.Normal weight="medium">{i18n.t('ats.cv_dropzone.label')}</Text.Normal>
              <Text.Normal>
                {i18n.t('ats.cv_dropzone.accepts', {
                  fileTypes: 'PDF, PNG, JPG, JPEG',
                })}
              </Text.Normal>
            </Box>
          </Box>
        </div>
      )}
    </Dropzone>
  )
}

const ACCEPTED_DOCUMENTS = {
  // Images
  'image/gif': ['.gif'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/webp': ['.webp'],

  // Video
  'video/mp4': ['.mp4'],
  'video/webm': ['.webm'],
  'video/quicktime': ['.mov', '.qt'],
  'video/x-msvideo': ['.avi'],

  // Documents
  'application/pdf': ['.pdf'],

  // Microsoft office
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.ms-powerpoint': ['.ppt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.xlsx'],

  // Apple
  'application/vnd.apple.pages': ['.pages'],
  'application/vnd.apple.keynote': ['.keynote'],
}
